/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type AddContactToRoleQueryVariables = {
    entityType: string;
};
export type AddContactToRoleQueryResponse = {
    readonly validEntityRoles: ReadonlyArray<{
        readonly name: string;
        readonly value: string;
    }>;
};
export type AddContactToRoleQuery = {
    readonly response: AddContactToRoleQueryResponse;
    readonly variables: AddContactToRoleQueryVariables;
};



/*
query AddContactToRoleQuery(
  $entityType: String!
) {
  validEntityRoles(entityType: $entityType) {
    name
    value
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "entityType"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "entityType",
        "variableName": "entityType"
      }
    ],
    "concreteType": "Role",
    "kind": "LinkedField",
    "name": "validEntityRoles",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddContactToRoleQuery",
    "selections": (v1/*: any*/),
    "type": "ApplicationQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddContactToRoleQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3eafbac667ab2436b1ef8543935ada61",
    "id": null,
    "metadata": {},
    "name": "AddContactToRoleQuery",
    "operationKind": "query",
    "text": "query AddContactToRoleQuery(\n  $entityType: String!\n) {\n  validEntityRoles(entityType: $entityType) {\n    name\n    value\n  }\n}\n"
  }
};
})();
(node as any).hash = '2699756732b3c82fd8365dcbeb677fb0';
export default node;
